import { Button, Flex, Box, VStack, Text, FormControl, FormLabel, Input, Select } from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useUser } from '../../../providers/UserProvider';

const AddAddress = () => {
    const { addAddress } = useUser();
    const [error, setError] = useState();

    const [info, setinfo] = useState(null);

    const formik = useFormik({
        initialValues: {
            address: "",
            phone: "",
            locality: "",
            pincode: "",
            city: "",
            state: "",
            country: "",
        },
        onSubmit: async (values) => {
            setError("");
            setinfo("Adding...");
            var res = await addAddress(values.address, values.phone, values.locality, values.city, values.state, values.pincode, values.country);
            setinfo(null);
            if (res === "err") {
                setError("Error Adding Contact !");
            } else {
                values.address = "";
                values.phone = "";
                values.locality = "";
                values.city = "";
                values.state = "";
                values.pincode = "";
                values.country = "";
            }
        }

    });

    return (
        <Flex minH='60vh' align="center" justify="center">
            <Box bg="white" p={6} maxW={'500px'} w='90%' rounded="0" shadow="md" my={6}>
                <form onSubmit={formik.handleSubmit}>
                    <VStack spacing={4} align="flex-start">
                        <Text fontSize='2xl' as='h3'>Add a new Address</Text>

                        {error ? <Box bg='red' w='100%' py='1' textAlign='center' color='white' > {error} </Box> : <></>}
                        {info && <Text color='blue'>{info}</Text>}
                        <FormControl>
                            <FormLabel htmlFor="address">Address</FormLabel>
                            <Input
                                id="address"
                                name="address"
                                type="text"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your Address'
                                onChange={formik.handleChange}
                                value={formik.values.address}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="phone">Phone</FormLabel>
                            <Input
                                id="phone"
                                name="phone"
                                type="number"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your Phone No'
                                onChange={formik.handleChange}
                                value={formik.values.phone}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="locality">Locality</FormLabel>
                            <Input
                                id="locality"
                                name="locality"
                                type="text"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your Locality'
                                onChange={formik.handleChange}
                                value={formik.values.locality}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="country">Country</FormLabel>
                            <Select
                                id="country"
                                name="country"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Select Country'
                                onChange={formik.handleChange}
                                value={formik.values.country}
                            >
                                <option value="United States">United States</option>
                                <option value="China">China</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Brazil">Brazil</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Russia">Russia</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Japan">Japan</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Egypt">Egypt</option>
                                <option value="Vietnam">Vietnam</option>
                                <option value="DR Congo">DR Congo</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Iran">Iran</option>
                                <option value="Germany">Germany</option>
                                <option value="Thailand">Thailand</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="France">France</option>
                                <option value="Italy">Italy</option>
                                <option value="South Africa">South Africa</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="South Korea">South Korea</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Spain">Spain</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Poland">Poland</option>
                                <option value="Algeria">Algeria</option>
                                <option value="Canada">Canada</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Peru">Peru</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Yemen">Yemen</option>
                                <option value="North Korea">North Korea</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Australia">Australia</option>
                                <option value="Syria">Syria</option>
                                <option value="Ivory Coast">Ivory Coast</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Romania">Romania</option>
                                <option value="Niger">Niger</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Mali">Mali</option>
                                <option value="Chile">Chile</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                                <option value="Chad">Chad</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Greece">Greece</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Somalia">Somalia</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Austria">Austria</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Israel">Israel</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Laos">Laos</option>
                                <option value="Libya">Libya</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Finland">Finland</option>
                                <option value="Congo">Congo</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Norway">Norway</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Ireland">Ireland</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="state">State</FormLabel>
                            <Input
                                id="state"
                                name="state"
                                type="text"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your State'
                                onChange={formik.handleChange}
                                value={formik.values.state}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="city">City</FormLabel>
                            <Input
                                id="city"
                                name="city"
                                type="text"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your City'
                                onChange={formik.handleChange}
                                value={formik.values.city}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="pincode">Pincode</FormLabel>
                            <Input
                                id="pincode"
                                name="pincode"
                                type="number"
                                required={true}
                                rounded='0'
                                size="lg"
                                placeholder='Your Pincode'
                                onChange={formik.handleChange}
                                value={formik.values.pincode}
                            />
                        </FormControl>
                        <Button type="submit" colorScheme='primary' py='7' width="full">
                            Add Address
                        </Button>
                    </VStack>
                </form>
            </Box>
        </Flex>
    );
};

export default AddAddress;
